<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <InformationSalarieSection />
  <CoordonneesSalarieSection />
  <TuteurSection />
</template>

<script setup lang="ts">
  import InformationSalarieSection from './sections/informationSalarie/InformationSalarieSection.vue'
  import TuteurSection from './sections/tuteur/TuteurSection.vue'
  import CoordonneesSalarieSection from './sections/coordonneesSalarie/CoordonneesSalarieSection.vue'
</script>
